document.addEventListener('DOMContentLoaded', function () {
  const messages = document.querySelectorAll('.top__bar--message');
  const topBar = document.querySelector('.top__bar');
  const nextButton = document.querySelector('.bar-next-js');
  let currentIndex = 0;
  const interval = parseInt(topBar.getAttribute('data-interval')) * 1000;

  function updateColors(element) {
    const bgColor = element.getAttribute('data-bg-color');
    const textColor = element.getAttribute('data-text-color');
    topBar.style.backgroundColor = bgColor;
    topBar.style.color = textColor;

    const paths = topBar.querySelectorAll('svg path');
    paths.forEach(function (path) {
      path.style.stroke = textColor;
    })
  }

  function showNextMessage() {
    const previousIndex = currentIndex;

    currentIndex = (currentIndex + 1) % messages.length;

    messages[previousIndex].classList.remove('active');
    messages[previousIndex].classList.add('previous');

    messages[currentIndex].classList.add('active');

    messages.forEach((message, index) => {
      if (index !== previousIndex) {
        message.classList.remove('previous');
      }
    })

    updateColors(messages[currentIndex]);
  }

  const initialMessage = messages[currentIndex];
  initialMessage.classList.add('active');
  updateColors(initialMessage);

  if (messages.length > 1) {
    let slideInterval = setInterval(showNextMessage, interval);

    nextButton.addEventListener('click', function () {
      clearInterval(slideInterval);
      showNextMessage();
      slideInterval = setInterval(showNextMessage, interval);
    })
  }
});
